module.exports = __webpack_public_path__ + "img/square-dark-monochrome.4752594.svg";